import type {JSX} from 'react';

import AfriexLogoSvg from '@/assets/svg/afriex-logo.svg';

export default function AfriexLogo({
  margin,
  label,
}: {
  margin?: string;
  label: string;
}): JSX.Element {
  return (
    <div className={`flex gap-1 ${margin || ''}`}>
      <img src={AfriexLogoSvg} alt="Afriex-Logo" className="w-7 h-7" />
      <div className="font-semibold text-gray-900 dark:text-white">{label}</div>
    </div>
  );
}
